import React from 'react';
import BreathingFlameMark from './BreathingFlameMark';

/**
 * IgnitingLoader — On-brand loading state for AI generation calls.
 *
 * Uses the official V4.5 flame PNG with the "lively" breathing animation
 * (3.4s synced scale + halo glow). Pure CSS, no extra deps.
 *
 * Usage:
 *   <IgnitingLoader label="Igniting your workout..." />
 */
const IgnitingLoader = ({ label = 'Igniting your workout...', size = 'lg' }) => {
  const isLg = size === 'lg';
  const markSize = isLg ? 160 : 96;
  const labelSize = isLg ? 'text-base' : 'text-sm';

  return (
    <div className="flex flex-col items-center gap-5 py-8" data-testid="igniting-loader">
      <div className="relative flex items-center justify-center" style={{ width: markSize, height: markSize }}>
        {/* Radial backdrop — only painted in Adaptive mode via CSS so the warm
            flame PNG has something to glow against on a sand background. */}
        <div className="igniting-loader-backdrop absolute inset-0 pointer-events-none rounded-full" aria-hidden="true" />
        <div className="relative z-10 flex items-center justify-center" style={{ width: markSize, height: markSize }}>
          <BreathingFlameMark size={markSize} intensity="lively" src="/brand/enferno-flame-mark-v46.png" />
        </div>
      </div>

      {label && (
        <div className={`font-display tracking-widest text-enf-text-secondary ${labelSize} enferno-loader-text uppercase`}>
          {label}
        </div>
      )}
    </div>
  );
};

export default IgnitingLoader;
